import React from 'react';
import styles from './HomePage.module.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const HomePage = ({ sites }) => {
    return (
        <div>
            <Helmet>
                <title>Citizens of the Internet | Personal Website Gallery | Home</title>
            </Helmet>
            <Nav />
            <section className={styles.hero}>
                <div className={styles.heroGrid}>
                    {sites.map((site) => (
                        <div className={styles.websiteCardContainer} key={site.id}>
                            <div className={styles.imageContainer}>
                                <Link
                                    className={styles.screenshotLink}
                                    to={`/${site.link}`}
                                    state={{ site }} // Pass site data via state prop
                                >
                                    <img
                                        src={site.images[0]}
                                        alt={site.name}
                                        className={styles.websiteCardScreenshot}
                                    />
                                    <div className={styles.hoverOverlay}>
                                        <button className={styles.siteDetailsBtn}>Details</button>
                                    </div>
                                </Link>
                            </div>
                            <div className={styles.websiteCardBottom}>
                                <div className={styles.websiteCardText}>
                                    <Link to={`/${site.link}`} state={{ site }}>
                                        <h4>{site.name}</h4>
                                    </Link>
                                    <p className={styles.personCategory}>{site.title}</p>
                                </div>
                                <div className={styles.buttonsContainer}>
                                    <Link
                                        className={styles.detailsBtnMobile}
                                        to={`/${site.link}`}
                                        state={{ site }}
                                    >
                                        <button className={styles.siteDetailsBtn}>Details</button>
                                    </Link>
                                    <a href={site.url[0]} target="_blank" rel="noopener noreferrer">
                                        <button>
                                            Visit
                                            <img
                                                className={styles.arrow}
                                                src="images/arrow-4.svg"
                                                alt="arrow"
                                            />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default HomePage;